(ns ncr.fragment-types.txt-viewer
  (:require
   [clojure.core.async :refer [go <!]]
   [clojure.core.match :refer [match]]
   [cljs-http.client :as http]
   [uix.core.alpha :as uix]
   [ncr.fragment-types.widgets :as ftw]))

(defn c-viewer [fragment-name attachment url close attachments set-preview]
  (let
    [text (uix/state nil)
     error-msg (uix/state nil)
     document-loading? (uix/state false)
     loader-id (uix/state 0)]

    (uix/with-effect [@loader-id]
      (go
        (reset! document-loading? true)
        (match (<! (http/get url {:with-credentials? false}))
          {:success true :body body}
          (do
            (reset! error-msg nil)
            (reset! document-loading? false)
            (reset! text body))

          {:success false :body body}
          (do
            (reset! error-msg body)
            (reset! document-loading? false)
            (reset! text nil)))))

    [:<>
     [ftw/c-toolbar fragment-name attachment close attachments set-preview]
     [ftw/c-content @error-msg @document-loading? #(swap! loader-id inc)
      (when-let [text @text]
        [:div.ncr-c-text-viewer text])]]))
